module.exports = __webpack_public_path__ + "img/gb93_1987.prt.4a585894.jpg";